import ServiceProvider from '@api-consent/classes/ServiceProvider';
import StaticTable from '@api-consent/util/StaticTable';
import data from './spsRaw';

export default new StaticTable(data.map((item) => new ServiceProvider(item)), { pick: 'SP301' });
